export default function TableHead({ id, columns, sortedField, handleSortingChange, order, filter }) {
    return (
        <thead style={filter && "box-shadow: 0 2px 3px black"}>
            <tr >
                {columns.map(({ label, accessor, sortable }) => {
                    const cl = sortable
                        ? sortedField === accessor && order === "asc"
                            ? "up"
                            : sortedField === accessor && order === "desc"
                                ? "down"
                                : "default"
                        : "";
                    return <th className={cl} key={accessor} onClick={sortable ? () => handleSortingChange(id, accessor) : null}>{label}</th>;
                })}
            </tr>
        </thead>
    );
}